import { Button } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import CrossedEyeIcon from "@/icons/CrossedEyeIcon";
import OpenEyeIcon from "@/icons/OpenEyeIcon";
const ButtonWithTrackEvent = withTrackEvent(Button);

interface ContentDrawerProps {
  toggleAll: () => void;
  allCollapsed: boolean;
  label: string;
}

const ContentDrawerComponent = ({
  toggleAll,
  allCollapsed,
  label,
}: React.PropsWithChildren<ContentDrawerProps>) => {
  const section = label ? ` in the ${label} section` : "";
  const action = allCollapsed ? "Expand" : "Collapse";

  return (
    <ButtonWithTrackEvent
      icon={{
        SvgComponent: allCollapsed ? OpenEyeIcon : CrossedEyeIcon,
      }}
      onClick={toggleAll}
      flavor={Button.flavors.tertiary}
      actionName={actionNames.hide}
      objectType={objectTypes.content}
      ariaProps={{
        "aria-controls": "content-drawers",
        "aria-expanded": !allCollapsed,
        "aria-label": `${action} all content${section}`,
      }}
      dataProps={{
        "data-testid": "content-drawers",
        "data-qa-selector": `content_drawers-${allCollapsed ? "show" : "hide"}`,
      }}
      streamProperties={{
        description: `${allCollapsed ? "Show" : "Hide"} all content drawers`,
      }}
    >
      {allCollapsed ? "Expand all" : "Collapse all"}
    </ButtonWithTrackEvent>
  );
};

export default ContentDrawerComponent;
